import { Link } from 'react-router-dom';
import { CalendarCheck, Phone } from '@phosphor-icons/react';
import { HeroVariant } from '../components/HeroVariant';
import { AboutBelowHero } from '../components/AboutBelowHero';
import { TrustBar } from '../components/TrustBar';
import { ServicesGrid } from '../components/ServicesGrid';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { BRAND, NASHVILLE_HEROES } from '../lib/brand';

/**
 * Home — Variant A · "Classic Nashville Skyline"
 * Polished, traditional, daylight feel.
 */
export const HomePageV1 = () => {
  return (
    <main data-testid="home-page-v1">
      <HeroVariant
        variant="v1"
        bg={NASHVILLE_HEROES.v1}
        eyebrow="Nashville · Tennessee"
        headlineLines={[
          { text: "Nashville's Premier" },
          { text: '24/7 Mobile Notary', shimmer: true },
          { text: '& Signing Service', italic: true },
        ]}
        subline="Providing safe, genuine, and legally binding signatures whenever and wherever you need them — from estate signings to expedited apostille and remote online notarization."
      />

      <AboutBelowHero />
      <TrustBar />
      <ServicesGrid />
      <WhyChooseUs />
      <Testimonials />

      {/* Final CTA */}
      <section className="py-24 bg-gradient-to-br from-[#FBF8F1] via-white to-[#FBF8F1] relative overflow-hidden">
        <div className="absolute top-12 left-1/2 -translate-x-1/2 h-px w-32 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#D4AF37] text-xs font-semibold tracking-[0.3em] uppercase mb-5">
            Ready When You Are
          </p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#800000] mb-6 leading-tight">
            Let's get your documents <span className="italic">signed.</span>
          </h2>
          <p className="text-base sm:text-lg text-[#5C5C5C] mb-10 max-w-2xl mx-auto leading-relaxed">
            Whether you need an emergency hospital signing tonight or an apostille for a flight tomorrow — India is one call away.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/booking"
              data-testid="cta-book-now-btn"
              className="inline-flex items-center gap-3 bg-[#800000] text-white hover:bg-[#5C0000] transition-all px-10 py-4 rounded-sm font-semibold text-sm tracking-[0.15em] uppercase shadow-xl hover:shadow-2xl hover:-translate-y-0.5"
            >
              <CalendarCheck weight="bold" size={22} />
              Book an Appointment
            </Link>
            <a
              href={`tel:${BRAND.phoneRaw}`}
              data-testid="cta-call-btn"
              className="inline-flex items-center gap-3 border-2 border-[#800000] text-[#800000] hover:bg-[#800000] hover:text-white transition-all px-10 py-4 rounded-sm font-semibold text-sm tracking-[0.15em] uppercase"
            >
              <Phone weight="bold" size={22} />
              Call 24/7
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};
